import { render, staticRenderFns } from "./YoungComments.vue?vue&type=template&id=63174f66&scoped=true&"
import script from "./YoungComments.vue?vue&type=script&lang=js&"
export * from "./YoungComments.vue?vue&type=script&lang=js&"
import style0 from "./YoungComments.vue?vue&type=style&index=0&id=63174f66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63174f66",
  null
  
)

export default component.exports